'use client';
import { useCurrentApplicant } from '@apply/hooks/applicant/queries/use-current-applicant';
import { UserInfo } from '@apply/types/user-info';
import { initialsOf } from '@core-systems/utils';
import { AvatarMenu, CircularLoader, Skeleton } from '@design-system';

export const ApplyAvatarMenu = ({
  children,
  variant = 'accordion',
}: {
  children: React.ReactNode;
  variant?: 'popover' | 'accordion';
}): React.JSX.Element => {
  const { applicant, isLoading, error } = useCurrentApplicant();

  if (isLoading)
    return (
      <AvatarMenu
        avatarFallback={<CircularLoader />}
        title={<Skeleton className="mb-xs h-[1em] w-full" />}
        subTitle={<Skeleton className="h-[1em] w-full" />}
        variant={variant}
      >
        {children}
      </AvatarMenu>
    );
  if (error || !applicant) return <></>;

  const userInfo: UserInfo = { usualName: applicant.usualName };
  const initials = initialsOf(userInfo.usualName);

  return (
    <AvatarMenu avatarFallback={initials} title={userInfo.usualName} subTitle={applicant.email} variant={variant}>
      {children}
    </AvatarMenu>
  );
};
